import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Tag } from 'primeng/tag';
import type { CreditOverviewUiState } from '../credit-overview.model';

@Component({
  selector: 'bn-credit-overview-state-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Tag],
  template: `
    <p-tag
      [value]="label()"
      [severity]="severity()"
      [icon]="icon()"
      [rounded]="true"
      styleClass="bn-credit-badge"
    />
  `,
})
export class CreditOverviewStateBadgeComponent {
  readonly state = input.required<CreditOverviewUiState>();

  label(): string {
    switch (this.state()) {
      case 'not_linked':
        return 'Not linked';
      case 'in_progress':
        return 'Linking in progress';
      case 'failed':
        return 'Linking failed';
      case 'linked':
        return 'Linked';
    }
  }

  severity(): 'secondary' | 'info' | 'danger' {
    switch (this.state()) {
      case 'not_linked':
        return 'secondary';
      case 'in_progress':
      case 'linked':
        return 'info';
      case 'failed':
        return 'danger';
    }
  }

  icon(): string {
    switch (this.state()) {
      case 'not_linked':
        return 'pi pi-minus-circle';
      case 'in_progress':
        return 'pi pi-clock';
      case 'failed':
        return 'pi pi-exclamation-triangle';
      case 'linked':
        return 'pi pi-check-circle';
    }
  }
}
